export default __webpack_public_path__ + "static/media/LSSR_terms_of_use.2f48a05c.pdf";